import React from "react";
import cloneDeep from "lodash/cloneDeep";
import { Input } from "components/bootstrap";
import { Select } from "components/common";
const OTX_INDICATORS = [
  { label: "IP Auto-Detect", value: "IPAutoDetect" },
  { label: "IP v4", value: "IPv4" },
  { label: "IP v6", value: "IPv6" },
  { label: "Domain", value: "domain" },
  { label: "Hostname", value: "hostname" },
  { label: "File", value: "file" },
  { label: "URL", value: "url" },
  { label: "CVE", value: "cve" },
  { label: "NIDS", value: "nids" },
  { label: "Correlation-Rule", value: "correlation-rule" }
];
const OTXAdapterFieldSet = ({ updateConfig, config, handleFormEvent, validationState, validationMessage }) => {
  const handleSelect = (fieldName) => (selectedIndicator) => {
    const newConfig = cloneDeep(config);
    newConfig[fieldName] = selectedIndicator;
    updateConfig(newConfig);
  };
  return /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "indicator",
      label: "Indicator",
      required: true,
      onChange: handleFormEvent,
      help: validationMessage("indicator", "The OTX indicator type that should be used for lookups."),
      bsStyle: validationState("indicator"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(
      Select,
      {
        placeholder: "Select indicator",
        clearable: false,
        options: OTX_INDICATORS,
        onChange: handleSelect("indicator"),
        value: config.indicator
      }
    )
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "api_key",
      name: "api_key",
      label: "OTX API Key",
      onChange: handleFormEvent,
      help: validationMessage("api_key", "Your OTX API key."),
      bsStyle: validationState("api_key"),
      value: config.api_key,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "api_url",
      name: "api_url",
      label: "OTX API URL",
      onChange: handleFormEvent,
      help: validationMessage("api_url", "URL of the OTX API server."),
      bsStyle: validationState("api_url"),
      value: config.api_url,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: "http_user_agent",
      name: "http_user_agent",
      label: "HTTP User-Agent",
      required: true,
      onChange: handleFormEvent,
      help: validationMessage("http_user_agent", "The User-Agent header that should be used for the HTTP request."),
      bsStyle: validationState("http_user_agent"),
      value: config.http_user_agent,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "number",
      id: "http_connect_timeout",
      name: "http_connect_timeout",
      label: "HTTP Connect Timeout",
      required: true,
      onChange: handleFormEvent,
      help: validationMessage("http_connect_timeout", "HTTP connection timeout in milliseconds."),
      bsStyle: validationState("http_connect_timeout"),
      value: config.http_connect_timeout,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "number",
      id: "http_write_timeout",
      name: "http_write_timeout",
      label: "HTTP Write Timeout",
      required: true,
      onChange: handleFormEvent,
      help: validationMessage("http_write_timeout", "HTTP write timeout in milliseconds."),
      bsStyle: validationState("http_write_timeout"),
      value: config.http_write_timeout,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "number",
      id: "http_read_timeout",
      name: "http_read_timeout",
      label: "HTTP Read Timeout",
      required: true,
      onChange: handleFormEvent,
      help: validationMessage("http_read_timeout", "HTTP read timeout in milliseconds."),
      bsStyle: validationState("http_read_timeout"),
      value: config.http_read_timeout,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ));
};
export default OTXAdapterFieldSet;
